<template>
    <v-date-picker ref="vDatePicker" :min-date="data.minDate"
                   :max-date="data.maxDate"
                   :color="data.dateColor"
                   :value="normalizedValue"
                   @input="input"
                   :mode="dateMode"
                   :is24hr="timeFormat==24"
                   :isDark="$store.state.theme.darkMode"
                   :masks="{
                       input:[dateFormat],
                       inputDateTime:[dateFormat+' h:mm A'],
                       inputDateTime24hr:[dateFormat+' HH:mm'],
                       inputTime:['h:mm A'],
                       inputTime24hr:['HH:mm']
                   }"
                   :isRange="isRange"
                                     :popover="{visibility: 'click', placement: data.popoverPosition}">
        <template v-slot="{ inputValue, inputEvents }">
            <div class="date-picker-input" :class="{'date-picker-input-group':borderGroup}">
                <div class="input-group"
                     :class="{'disabled':data.disabled}"
                                         @focusin="handleFocusIn"
                                         @focusout="handleFocusOut">
                    <template v-if="isRange">
                        <input :value="inputValue.start || inputValue.end ? inputValue.start+' - '+inputValue.end: ''"
                               :placeholder="data.placeholder"
                               readonly
                               v-on="inputEvents.start || inputEvents.end"
                               class="form-control"/>
                    </template>
                    <template v-else>
                        <input :value="inputValue ? inputValue : ''"
                               :placeholder="data.placeholder"
                               v-on="inputEvents"
                               class="form-control"/>
                    </template>
                    <div class="input-group-append">
                        <span class="input-group-text">
                            <app-icon :name="'calendar'"/>
                        </span>
                    </div>
                </div>
            </div>
        </template>
    </v-date-picker>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';
import CoreLibrary from "../../helpers/CoreLibrary";
import moment from "moment";

export default {
    name: "DatePicker",
    extends: CoreLibrary,

    mixins: [InputMixin],

    data() {
        return {
            borderGroup: false,
        }
    },
        mounted() {
            // Listen for global close requests so only one calendar stays open
            if (this.$root && this.$root.$on) {
                this.$root.$on('close-all-datepickers', this.handleExternalClose);
            }
        },
        beforeDestroy() {
            if (this.$root && this.$root.$off) {
                this.$root.$off('close-all-datepickers', this.handleExternalClose);
            }
        },
    computed: {
      // value(){
      //   console.info(this.data.fieldValue)
      //   return this.fieldValue ? this.fieldValue : this.data.initialValue
      // },
        isRange() {
            if (this.data.dateMode === 'range') {
                return true
            }
            return this.isUndefined(this.data.isRange) ? false : this.data.isRange;
        },
        dateMode() {
            if (this.data.dateMode === 'range' || this.isUndefined(this.data.dateMode)) {
                return 'date';
            } else return this.data.dateMode;
        },
      normalizedValue() {
        // Handle range mode
        if (this.isRange && typeof this.value === 'object' && this.value.start && this.value.end) {
          return {
            start: this.parseDate(this.value.start),
            end: this.parseDate(this.value.end),
          };
        }

        // Handle single value
        return this.parseDate(this.value);
      }
      },
    methods: {
                handleFocusIn(event) {
                        this.borderGroup = true;
                        // ask other pickers to close; include our uid so listeners can ignore themselves
                        if (this.$root && this.$root.$emit) this.$root.$emit('close-all-datepickers', this._uid);
                },
                handleFocusOut(event) {
                        this.borderGroup = false;
                },

                handleExternalClose(openedUid) {
                        // If the event came from this same instance, do nothing
                        if (openedUid === this._uid) return;
                        // Try common API names for hiding the popover on the underlying v-date-picker
                        const picker = this.$refs.vDatePicker;
                        try {
                            if (!picker) return;
                            if (typeof picker.hidePopover === 'function') picker.hidePopover();
                            else if (typeof picker.hide === 'function') picker.hide();
                            else if (typeof picker.close === 'function') picker.close();
                            else if (picker.$el) {
                                // fallback: try to find a popover element inside DOM and hide it
                                const pop = picker.$el.querySelector('.vc-popover, .vdp-popup, .v-date-picker__popover');
                                if (pop) pop.style.display = 'none';
                            }
                        } catch (e) {
                            // don't break UI if method calls fail
                            console.debug('handleExternalClose: could not programmatically hide other datepicker', e);
                        }
                },
        input(date) {
            this.fieldValue = date;
            this.$emit('input', date);
        },
      parseDate(value) {
        if (!value) return value;

        // Try to parse DD-MM-YYYY using moment
        const parsed = moment(value, 'DD-MM-YYYY', true);
        if (parsed.isValid()) {
          return parsed.toDate();
        }

        // Fallback: try default parsing (could be ISO or native Date object)
        return value;
      }
    },
}
</script>

